import { Caption } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { ItemCardPriceRow } from '@/components/GridItemCard/Card/components/ItemCardPriceRow/ItemCardPriceRow';
import ItemCardMenu from '@/components/ItemCard/components/Menu/ItemCardMenu';
import { useAppSelector } from '@/redux/hooks';
import { isUserLoggedIn } from '@/redux/modules/account/user/user.selectors';
import {
    getItemSummaryBidCount,
    getItemSummaryIsBuyNowOnly,
    getItemSummaryIsLocked,
    getItemSummaryIsPassed,
    getItemSummaryIsSold,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import { getLiveItemStatusOpen } from '@/redux/modules/liveItemStatus';
import { useAppFormatMessage } from '@/utils/intl/useAppFormatMessage';

export type CardPriceProps = {
    enterLinkHoverState: () => void;
    hideCardMenu?: boolean;
    isCardHovered: boolean;
    isLinkHovered: boolean;
    itemId: number;
    leaveLinkHoverState: () => void;
    onNavigate?: () => void;
};

export const CardPrice = ({
    enterLinkHoverState,
    hideCardMenu = false,
    isCardHovered,
    isLinkHovered,
    itemId,
    leaveLinkHoverState,
    onNavigate,
}: CardPriceProps) => {
    const formatMessage = useAppFormatMessage();
    const isLoggedIn = useAppSelector(isUserLoggedIn);
    const bidCount = useAppSelector((state) => getItemSummaryBidCount(state, itemId));
    const isBuyNowOnly = useAppSelector((state) => getItemSummaryIsBuyNowOnly(state, itemId));
    const isLotOpen = useAppSelector((state) => getLiveItemStatusOpen(state, itemId));
    const isPassed = useAppSelector((state) => getItemSummaryIsPassed(state, itemId));
    const isSold = useAppSelector((state) => getItemSummaryIsSold(state, itemId));
    const isLocked = useAppSelector((state) => getItemSummaryIsLocked(state, itemId));

    const isPending = isLocked && !isPassed && !isSold && !isLotOpen;

    return (
        <section className="flex flex-col justify-between [grid-area:currentbidprice]">
            <section className="flex justify-between">
                <section className="flex flex-wrap items-center gap-x-2xs">
                    <ItemCardPriceRow
                        isHovered={isLinkHovered}
                        itemId={itemId}
                        onMouseEnter={enterLinkHoverState}
                        onMouseLeave={leaveLinkHoverState}
                        onNavigate={() => onNavigate?.()}
                    />
                    {!isSold && !isPassed && !isPending && !isBuyNowOnly && bidCount > 0 && (
                        <Caption
                            className={cn(isLinkHovered && 'text-link-hover underline')}
                            onMouseEnter={enterLinkHoverState}
                            onMouseLeave={leaveLinkHoverState}
                        >
                            {formatMessage(['itemBidding', 'bid'], { values: { bidCount } })}
                        </Caption>
                    )}
                </section>
                {isLoggedIn && !hideCardMenu && (
                    <ItemCardMenu
                        itemId={itemId}
                        showIcon={isCardHovered}
                    />
                )}
            </section>
        </section>
    );
};
